import React, { FC } from "react";
import { CsobFormMetaDataDto, QuestionnaireType } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { Tooltip } from "@components/base";
import { Chip } from "@components/common";

interface ChipWithTooltip {
  form: CsobFormMetaDataDto;
  hideTooltip?: boolean;
}

const ChipWithTooltip: FC<ChipWithTooltip> = ({ form, hideTooltip }) => {
  const { t } = useTranslation();
  const chipElement = (
    <Chip
      label={t(`csob.questionnaires.chip.${form.questionnaireType}`)}
      color="primary"
      size="small"
      type={form.questionnaireType}
    />
  );

  if (hideTooltip) {
    return chipElement;
  }

  return form.questionnaireType === QuestionnaireType.Client ? (
    <Tooltip arrow title={t("csob.questionnaires.clientTooltip")} placement="top">
      <span>{chipElement}</span>
    </Tooltip>
  ) : form.questionnaireType === QuestionnaireType.EnergyAsset ? (
    <Tooltip arrow title={t("csob.questionnaires.text")} placement="top">
      <span>{chipElement}</span>
    </Tooltip>
  ) : (
    chipElement
  );
};

export default ChipWithTooltip;
